import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export const FIRST_LAST_INITIAL = 'FIRST_LAST_INITIAL'
export const FULL_NAME = 'FULL_NAME'

export default class User extends PureComponent {
  static propTypes = {
    format: PropTypes.oneOf([FIRST_LAST_INITIAL, FULL_NAME]),
    user: PropTypes.object
  }

  static defaultProps = {
    user: {},
    format: FULL_NAME
  }

  formatName() {
    const { format, user } = this.props
    const firstName = user.firstName || ''
    const lastName = user.lastName || ''

    switch (format) {
      case FIRST_LAST_INITIAL:
        return `${firstName} ${lastName.slice(0, 1)}.`
      case FULL_NAME:
        return `${firstName} ${lastName}`
    }
  }

  render() {
    return <span>{this.formatName()}</span>
  }
}



// WEBPACK FOOTER //
// ../src/components/User.js